var _defs, _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 27",
    width: 28,
    height: 27,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1235-62h1920v3083h-1920z"
  })), /*#__PURE__*/React.createElement("image", {
    width: 28,
    height: 27,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAbCAMAAABY1h8eAAAAAXNSR0IB2cksfwAAARdQTFRFGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvGCAvoQzTsAAAAF10Uk5TABA6X4OeudDh8f/+7d3MtZl9WDIKBKH99XtmzaiJb1ZFNSogLjhIWXWPrtP4M5yVAsRroICxcJSl2WFQ+kN5/CEBu/ZCeA/Jl3b0J03OpmAGLOAvBb8emPc2zzfvN7N5FwAAAOFJREFUeJy90Fs3QmEQxvFnR9JDOUXoQLZjkZxVu9hIzuUsfP/PYV4XLe133Pa/mJm1fncDwAkNDIaHIsNRmkZGY/Gx8YnJqQSA6Zkk1WbngHkymkpnsguLuSVXWl5ZXVvfyBc2yS0UuQ2t0g53scd9FXHAQxzxWMcyK6jSq2lW58kp/DOeX9jWIDOyLpuKil350LVriv4xS3ssoAHr0eug/erNrTnubBONsGj2PR8sA1osyGyTj7bJH59kOqTTb3xm8uU/dJt8Vczg27vHj46Onkd+fmkmKFRVvmNyv1NB+gELtCfP5UpeowAAAABJRU5ErkJggg=="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#img1",
    x: 0,
    y: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.bcbdd14eaa9b0259f67ad518c7f03eb3.svg";
export { ForwardRef as ReactComponent };